module.exports = __webpack_public_path__ + "static/media/DocumentAccepted.b31e1b1b.svg";